import { rest } from 'msw'

import { getResponseObject } from '@webapp/tests'
import { CardholderApiModelStub } from '../api-models/stubs/CardholderApiModel.stub'

export const mockGetCardholdersResponse = (
  cardholderStubs = CardholderApiModelStub.buildList(1)
) => {
  return rest.get(`/api/v3/pay/cardholders/`, (_, res, ctx) => {
    return res.once(
      ctx.status(200),
      ctx.json(getResponseObject(cardholderStubs))
    )
  })
}

export const mockGetCardholdersError = () => {
  return rest.get(`/api/v3/pay/cardholders/`, (_, res, ctx) => {
    return res.once(ctx.status(401), ctx.json({}))
  })
}
